function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["borderWeight", "chatBubble", "children", "className", "element", "fill", "heading", "headingLevel", "id", "size", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { createEnum, ValidPropTypes, makeErrorBoundComponent, appendClass } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var CardTypes = createEnum(['default', 'primary', 'secondary', 'info', 'confirm', 'warn', 'alert']);
var CardBorderWeights = createEnum(['none', 'light', 'medium', 'heavy']);
var CardSizes = createEnum(['x-small', 'small', 'medium']);
var CardElements = createEnum(['address', 'aside', 'div', 'figure', 'section']);
var CardHeadingLevels = createEnum(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);
var CardChatBubble = createEnum(['left', 'right']);
var defaults = {
  borderWeight: CardBorderWeights.LIGHT,
  className: "",
  element: CardElements.DIV,
  fill: false,
  heading: "",
  headingLevel: CardHeadingLevels.H2,
  id: null,
  size: CardSizes.SMALL,
  type: CardTypes.DEFAULT,
  chatBubble: null
};
var Card = function Card(_ref) {
  var _ref$borderWeight = _ref.borderWeight,
    borderWeight = _ref$borderWeight === void 0 ? defaults.borderWeight : _ref$borderWeight,
    _ref$chatBubble = _ref.chatBubble,
    chatBubble = _ref$chatBubble === void 0 ? defaults.chatBubble : _ref$chatBubble,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? defaults.element : _ref$element,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? defaults.fill : _ref$fill,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? defaults.heading : _ref$heading,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? defaults.headingLevel : _ref$headingLevel,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaults.size : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaults.type : _ref$type,
    rootProps = _objectWithoutProperties(_ref, _excluded);
  var classes = classnames("card", "c-els-card", className, {
    "c-els-card--fill": fill,
    "c-els-card--type-default": type === CardTypes.DEFAULT,
    "c-els-card--type-primary": type === CardTypes.PRIMARY,
    "c-els-card--type-secondary": type === CardTypes.SECONDARY,
    "c-els-card--type-info": type === CardTypes.INFO,
    "c-els-card--type-confirm": type === CardTypes.CONFIRM,
    "c-els-card--type-warn": type === CardTypes.WARN,
    "c-els-card--type-alert": type === CardTypes.ALERT,
    "c-els-card--border-width-none": borderWeight === CardBorderWeights.NONE,
    "c-els-card--border-width-1o16": borderWeight === CardBorderWeights.LIGHT,
    "c-els-card--border-width-1o8": borderWeight === CardBorderWeights.MEDIUM,
    "c-els-card--border-width-1o4": borderWeight === CardBorderWeights.HEAVY,
    "c-els-card--size-x-small": size === CardSizes.X_SMALL,
    "c-els-card--size-small": size === CardSizes.SMALL,
    "c-els-card--size-medium": size === CardSizes.MEDIUM,
    "c-els-card--has-heading": !!heading,
    "c-els-card--chat-bubble-left": chatBubble === CardChatBubble.LEFT,
    "c-els-card--chat-bubble-right": chatBubble === CardChatBubble.RIGHT
  });
  var headingClasses = classnames("card__heading", "c-els-card__heading", appendClass({
    className: className,
    value: "heading",
    delimiter: "__"
  }));
  var contentClasses = classnames("card__content", "c-els-card__content", appendClass({
    className: className,
    value: "content",
    delimiter: "__"
  }));
  var headingIsString = typeof heading === "string";
  var ComponentElement = element;
  var ComponentHeadingLevel = headingLevel;
  if (!CardHeadingLevels.getAll().includes(headingLevel)) {
    throw new TypeError("The headingLevel property (".concat(headingLevel, ") must be one of ").concat(CardHeadingLevels.getAll().join(", ")));
  }
  return /* @__PURE__ */React.createElement(ComponentElement, _objectSpread({
    className: classes,
    id: id,
    "data-testid": "card"
  }, rootProps), heading && headingIsString && /* @__PURE__ */React.createElement(ComponentHeadingLevel, {
    className: headingClasses
  }, heading), heading && !headingIsString && /* @__PURE__ */React.createElement("div", {
    className: headingClasses
  }, heading), /* @__PURE__ */React.createElement("div", {
    className: contentClasses
  }, children));
};
Card.displayName = "Card";
Card.propTypes = {
  /** The weight of the border of the Card */
  borderWeight: PT.oneOf(CardBorderWeights.getAll()),
  /** Whether to render the Card as a chat bubble */
  chatBubble: PT.oneOf(CardChatBubble.getAll()),
  /** What to render in the Card as content, either text or HTML */
  children: PT.node.isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: PT.string,
  /** The semantic tag to use for the root element of the Card */
  element: PT.string,
  /** Background fill color of the card. Only affects heading if present. */
  fill: PT.bool,
  /** The heading of the Card */
  // DEPRECATED: Use string or JSX instead of function
  heading: PT.oneOfType([PT.string, PT.func, PT.element]),
  /** The heading level of the Card */
  headingLevel: PT.oneOf(CardHeadingLevels.getAll()),
  /** ID for the Card */
  id: PT.string,
  /** The size of the padding around the content in the Card */
  size: PT.oneOf(CardSizes.getAll()),
  /** Type of Card to use */
  type: PT.oneOf(CardTypes.getAll())
};
Card.requiredProps = {
  children: ValidPropTypes.NODE
};
Card.Types = CardTypes;
Card.BorderWeights = CardBorderWeights;
Card.Sizes = CardSizes;
Card.Elements = CardElements;
Card.HeadingLevels = CardHeadingLevels;
Card.ChatBubble = CardChatBubble;
Card.defaults = defaults;
var RawCard = Card;
var Card$1 = makeErrorBoundComponent(RawCard);
export { Card$1 as Card, RawCard };
